import React from 'react'
import {
  CANCEL_CHARGE_NOTE,
  AMEND_CHARGE_NOTE,
  FARE_RULE_ERROR
} from 'AccountsConstants/language/cancellation'
import FareRules from './FareRules'

const AirToolTip = ({ header, fare }) => {
  return (
    <React.Fragment>
      <div className="c-white">
        <section className="pb-2 bc-white">
          <div className="flex">
            <If condition={fare && Object.keys(fare.fareDetails).length > 0 &&
              (fare.fareDetails.cancelCharges ||
                fare.fareDetails.amendSameFareCharges ||
                fare.fareDetails.amendHigherFareCharges)}
            >
              <div className="right-side">
                <h2 className="fs-12 c-white">Cancellation fee per person</h2>
                <FareRules isPWA={true} showArrDest={false} property="cancelCharges" data={fare} isDeskTopView={true} />
                <p className="fs-10 c-grey-40">{CANCEL_CHARGE_NOTE}</p>
              </div>
              <div className="left-side pl-5">
                <h2 className="fs-12 c-white">Flight change fee per person</h2>
                <FareRules isPWA={true} showArrDest={false} property="amendSameFareCharges" isDeskTopView={true} data={{ ...fare, cancelCharges: null }} />
                <p className="fs-10 c-grey-40">{AMEND_CHARGE_NOTE}</p>
              </div>
              <Else />
              <p className="pt-2 pl-4 fs-10">{FARE_RULE_ERROR}</p>
            </If>
          </div>
        </section>
      </div>
    </React.Fragment>
  )
}
const VerticalToolTipBody = ({ vertical, data }) => (
  <If condition={data}>
    <AirToolTip {...data} />
  </If>
)

export default VerticalToolTipBody
